module.exports = __webpack_public_path__ + "src/assets/img/share/07b60bb90cfad1c63f45d754c343c55e.png";